const TIME_REG = /^([1-9]|0[1-9]|1[0-9]|2[0-4])$/;
const TIME_SUFFIX_REG = /^(([1-9]|0[1-9]|1[0-9]|2[0-4])(\.|:))$/;
const TIME_A_REG =  /^(([1-9]|0[1-9]|1[0-2])(a|p))$/;
const TIME_AM_REG =  /^(([1-9]|0[1-9]|1[0-2])(a|p)m)$/;
const TIME_ALL_REG = /^(([1-9]|0[0-9]|1[0-9]|2[0-4])(\.|:)([0-5][0-9]|[0-9]))$/;
const TIME_ALL_A_REG = /^(([1-9]|0[0-9]|1[0-2])(\.|:)([0-5][0-9]|[0-9])(a|p))$/;
const TIME_ALL_AM_REG = /^(([1-9]|0[0-9]|1[0-2])(\.|:)([0-5][0-9]|[0-9])(a|p)m)$/;


export function validTime(value) {
  const value_no_space = value ? value.replace(/\s+/g,"") : '';
	return value_no_space.length === 0 || TIME_REG.test(value_no_space) || TIME_SUFFIX_REG.test(value_no_space)|| TIME_A_REG.test(value_no_space) || TIME_AM_REG.test(value_no_space)|| TIME_ALL_REG.test(value_no_space) || TIME_ALL_A_REG.test(value_no_space) ||TIME_ALL_AM_REG.test(value_no_space) || false
}

export function validTimeRule(value) {
  const value_no_space = value ? value.replace(/\s+/g,"") : '';
	return value_no_space.length === 0 || TIME_REG.test(value_no_space) || TIME_SUFFIX_REG.test(value_no_space)|| TIME_A_REG.test(value_no_space) || TIME_AM_REG.test(value_no_space)|| TIME_ALL_REG.test(value_no_space) || TIME_ALL_A_REG.test(value_no_space) ||TIME_ALL_AM_REG.test(value_no_space) || 'Invalid format.'
}